import {Component, OnInit} from '@angular/core';
import {LoginService} from '../../shared/services/login.service';
import {Router} from '@angular/router';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
  selector: 'app-guest-user',
  templateUrl: './guest-user.component.html',
  styleUrls: ['./guest-user.component.css']
})
export class GuestUserComponent implements OnInit {

  validationSummary: string;

  constructor(private loginService: LoginService, private router: Router) {
  }

  ngOnInit() {
    this.guestLogin();
  }

  guestLogin(): void {
    this.loginService.guestLogin(this.guestLoginOkCb.bind(this), this.guestLoginErrorCb.bind(this));
  }

  guestLoginOkCb(ok: boolean): void {
    const tempReturnUrl = '/sdai';
    if (typeof (ok) === 'boolean') {
      if (!ok) {
        this.validationSummary = 'Error occurred while logging in guest user.';
      }
    }
    this.router.navigate([tempReturnUrl]);
  }

  guestLoginErrorCb(err: HttpErrorResponse): void {
    this.validationSummary = err.error.message;
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-users/guest-user/guest-user.component.ts